import { useRef } from 'react'

export const useFrozenValue = <T>(value: T, frozen: boolean): T => {
  const ref = useRef(value)
  if (!frozen) {
    ref.current = value
  }
  return ref.current
}
